<template>
  <div>
    <h5 class="p-1 text-center">Daftar Data Masjid</h5>

    <div class="pengajuan mb-3">
      <div class="item">
        <div class="title">Dalam Proses</div>
        <div class="value">{{ registered_stat }}</div>
      </div>
      <div class="item">
        <div class="title">Terverifikasi</div>
        <div class="value">{{ verified_stat }}</div>
      </div>
      <div class="item">
        <div class="title">Ditolak</div>
        <div class="value">{{ rejected_stat }}</div>
      </div>
    </div>
    <div>
      <div class="row mb-3 mt-3">
        <div class="col-4">
          <select
            name="type"
            id="type"
            class="form-control"
            v-model="filterRegistered"
          >
            <option value="">-- Pilih Filter --</option>
            <option value="all">Semua</option>
            <option value="verified">Terverifikasi</option>
            <option value="registered">Dalam Proses</option>
            <option value="rejected">Ditolak</option>
          </select>
        </div>
        <div class="col-8">
          <div class="search">
            <input
              type="text"
              name="namamasjid"
              id="namamasjid"
              class="form-control"
              v-model="searchRegistered"
            />
            <button
              class="btn btn-main btn-search"
              @click="filterRegister"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="mb-5" v-if="registered.length > 0">
        <a
          href="#"
          @click="showForm(register)"
          v-for="register in registered"
          :key="register.id"
          class="box-masjid shadow-sm"
        >
          <div class="row mb-2 status">
            <div class="col-6">
              Pengurus: <strong>{{ register.pengurus }}</strong>
            </div>
            <div class="col-6" style="text-align:right">
              Status:
              <span
                class="label"
                :class="loadLabel(register.is_verifikasi)"
              >
                <strong>{{
                  loadStatus(register.is_verifikasi)
                }}</strong>
              </span>
            </div>
          </div>
          <div v-if="register.img_masjid" class="img">
            <img :src="register.img_masjid" alt="image-masjid" />
          </div>
          <div class="masjid-title">
            {{ register.nama_masjid }}
          </div>
          <div class="alamat">
            {{ register.alamat_masjid }}
          </div>
          <div class="jenis_akusisi">
            Jenis Akusisi :
            <strong>{{ register.acquisition_type }}</strong>
          </div>
        </a>
      </div>
      <div v-else>
        <div class="mb-5 mt-3 alert alert-warning">
          <center>Tidak ada data.</center>
        </div>
      </div>
      <div style="display:flex; gap: 5px;">
        <button
          href="javascript:void(0)"
          class="btn button-kembali"
          @click="backToGate"
        >
          Kembali
        </button>
        <button
          @click="loadMoreRegistered"
          class="btn button-daftarkan"
        >
          Lainnya
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/masjedapi';

export default {
  data() {
    return {
      registered: [],
      verified: [],
      lastdate: '',
      lastdateVerified: '',
      reffcode: '',
      namamasjid: '',
      filterRegistered: '',
      searchRegistered: '',
      searchVerified: '',
      registered_stat: 0,
      verified_stat: 0,
      rejected_stat: 0,
    };
  },
  methods: {
    backToGate() {
      this.$router.push({
        name: 'akusisi-user-report-relawan',
        params: { ref_code: this.reffcode },
      });
    },
    loadStatus(status) {
      switch (status) {
        case 0:
          return 'Dalam Proses';
        case 1:
          return 'Terverifikasi';
        case 2:
          return 'Ditolak';
        default:
          break;
      }
    },
    loadLabel(status) {
      switch (status) {
        case 0:
          return 'process';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          break;
      }
    },
    filterRegister() {
      this.registered = [];
      this.lastdate = '';
      this.loadRegistered();
    },
    loadRegistered() {
      let status = '';
      const ref_code = this.$route.params.ref_code;
      const self = this;

      if (this.filterRegistered != '') {
        status = this.filterRegistered;
      }

      var url = `/daftarkan/list-masjid?reffcode=${ref_code}`;

      if (this.status != '') url = `${url}&status=${status}`;

      if (this.lastdate != '')
        url = `${url}&lastdate=${this.lastdate}`;

      if (this.searchRegistered)
        url = `${url}&nama_masjid=${this.searchRegistered}`;

      axios.get(url).then(function(response) {
        const { data, meta } = response.data;
        if (self.lastdate == '') {
          self.registered = data;
        } else {
          if (data.length > 0) {
            self.registered.push(...data);
          }
        }
        self.lastdate = meta.lastdate;
        self.registered_stat = meta.registered;
        self.verified_stat = meta.verified;
        self.rejected_stat = meta.rejected;
      });
    },
    loadMoreRegistered() {
      if (this.lastdate != '') this.loadRegistered();
    },
    filterVerified() {
      this.lastdateVerified = '';
      this.loadVerified();
    },
    loadVerified() {
      const ref_code = this.$route.params.ref_code;
      const self = this;
      var url = `/daftarkan/list-masjid?reffcode=${ref_code}&status=verified`;

      if (this.lastdateVerified != '')
        url = `${url}&lastdate=${this.lastdateVerified}`;

      if (this.searchVerified)
        url = `${url}&nama_masjid=${this.searchVerified}`;

      axios.get(url).then(function(response) {
        const { data, meta } = response.data;
        if (self.lastdateVerified == '') {
          self.verified = data;
        } else {
          if (data.length > 0) {
            self.verified.push(...data);
          }
        }
        self.lastdateVerified = meta.lastdate;
      });
    },
    loadMoreVerified() {
      if (this.lastdateVerified != '') this.loadVerified();
    },
    showForm(register) {
      this.$router.push({
        name: 'akusisi-user-dkm-view',
        params: { ref_code: this.reffcode, id: register.id },
      });
    },
  },
  mounted() {
    this.loadRegistered();
    this.loadVerified();
    this.reffcode = this.$route.params.ref_code;
  },
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  border: none !important;
  .nav-item {
    flex: 1 !important;
    padding: 2px !important;

    .nav-link {
      border: none !important;
      width: 100% !important;
    }

    .active {
      font-weight: bold !important;
    }
  }
}

.tab-content {
  padding: 10px;
}

.box-masjid {
  display: block;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #eee;
  margin-top: 20px;
  text-decoration: none;
  color: #000;

  .masjid-title {
    font-weight: bold;
    font-size: 18px;
    padding: 5px 0px;
  }
  .img {
    background: #ccc;
    height: 190px;
    overflow: hidden;
    border-radius: 5px;

    img {
      display: block;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  .status {
    font-size: 12px;
  }
}

.label {
  color: #fff;
  border-radius: 2px;
  padding: 2px 10px;
  font-size: 11px;
}

.process {
  background: #a79a28;
}

.success {
  background: #28a745;
}

.danger {
  background: #a72828;
}

.search {
  position: relative;
  input {
    padding-right: 75px;
  }
  .btn-search {
    position: absolute;
    right: 0px;
    top: 0px;
    padding: 5px 20px;
    border-radius: 2px !important;
    background: #20d2a6 !important;
  }
}

.pengajuan {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 5px 0px;

  .item {
    flex: 1;
  }
  .title {
    font-size: 12px;
    padding: 0px;
    margin: 0px;
    text-align: center;
  }
  .value {
    font-size: 25px !important;
    font-weight: normal;
    padding: 5px 0px;
    text-align: center;
  }
}

.button-daftarkan {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  background: #20d2a6 !important;
  color: #fff !important;
  width: 100% !important;
  border-radius: 5px !important;

  &:hover {
    background: #189e7d !important;
  }
}

.button-kembali {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  border-radius: 5px !important;
  background: #e62020 !important;
  color: #fff !important;
  width: 100% !important;

  &:hover {
    background: #991515 !important;
  }
}

.jenis_akusisi {
  font-size: 12px;
}
</style>
